import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

const navLinks = [
  { to: '/', label: 'O meni', short: 'O meni' },
  { to: '/psychotherapy', label: 'Psihoterapija', short: 'Psihoterapija' },
  { to: '/psychology', label: 'Psihološko svetovanje', short: 'Svetovanje' },
  { to: '/fields', label: 'Področja dela', short: 'Področja dela' },
  { to: '/pricelist', label: 'Cenik', short: 'Cenik' },
  { to: '/contact', label: 'Kontakt', short: 'Kontakt' },
];

export default function Header() {
    const [menuOpened, setMenuOpened] = useState(false);
    const location = useLocation();

    const openCloseMobileMenu = () => {
        setMenuOpened(!menuOpened);
    };

    const isActive = (path) => {
        return location.pathname === path ? 'text-[rgb(61,62,77)]' : 'text-headerColor';
    };

    return (
        <>
        <div className='container w-full'>
            <div className="flex sm:hidden flex">
                <div className="flex items-center">
                    <Link to="/">
                        <img src="/assets/logo_mobile.svg" className="w-8 h-8 cursor-pointer" alt="Psihoterapija Špela Verbnik" />
                    </Link>
                </div>
                <div className="flex items-center ml-auto">
                    <img src="/assets/logo_burger.svg" className="w-8 h-8" alt="Meni" onClick={openCloseMobileMenu} />
                </div>
            </div>
            <div className='dropdown dropdown_menu none'>
                <ul className='text-right'>
                    {navLinks.map((link, index) => (
                    <li key={link.to} className={`${menuOpened ? `pt-1 dropdown_item_active dropdown_item-${Math.min(index + 1, 5)}` : 'dropdown_item'}`}>
                        <Link to={link.to} className={`whitespace-nowrap cursor-pointer ${isActive(link.to)}`} onClick={() => setMenuOpened(false)}>{link.label}</Link>
                    </li>
                    ))}
                </ul>
            </div>
        </div>
        <div className="container w-full bg-white pt-6 pb-6">
            <div className="flex sm:flex hidden pl-10 pr-10 justify-center">
                <div className="flex items-center justify-center w-full">
                    <Link to="/" className='w-1/2'>
                        <img src="/assets/logo_full_short.svg" className="w-full cursor-pointer" alt="Psihoterapija Špela Verbnik" />
                    </Link>
                </div>
            </div>
        </div>
        <div className="container w-full pt-2">
            <div className="flex sm:flex hidden pl-6 pr-6 pb-12">
                <div className="flex w-full max-w-5xl justify-center m-auto items-center gap-4 lg:gap-6 flex-wrap">
                    {navLinks.map((link) => (
                      <Link key={link.to} to={link.to} className={`text-center font-inter whitespace-nowrap cursor-pointer text-base lg:text-lg ${isActive(link.to)}`}>{link.short}</Link>
                    ))}
                </div>
            </div>
        </div>
        </>
        
    );
}
